module.exports = __webpack_public_path__ + "static/media/NominatimSearch.c06caaea.less";